import {
  WhmButton,
  WhmCard,
  WhmCardContent,
  WhmStack,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { useNavigate } from "react-router";
import { Translate } from "../../Translation/Translate";
import translationKeys from "../../../contexts/I18nContext/translationKeys";
import { OnboardingStatusDto } from "../../../data/dtos/onboarding-status.dto";

const EXPLORE_OFFERINGS_URL = "/primary-market";

type EntityOnboardingInReviewCardProps = {
  data: OnboardingStatusDto;
};

function EntityOnboardingInReviewCard({
  data,
}: EntityOnboardingInReviewCardProps) {
  const navigate = useNavigate();

  const origin = data.onboardingOrigin;
  const issuerReturnUrl = origin?.issuerReturnUrl;
  const isNie =
    !!origin?.issuerName &&
    !!issuerReturnUrl &&
    /^https?:\/\//i.test(issuerReturnUrl);
  const issuerName = origin?.issuerName ?? "";

  const handleCtaClick = () => {
    if (isNie && issuerReturnUrl) {
      window.location.href = issuerReturnUrl;
      return;
    }
    navigate(EXPLORE_OFFERINGS_URL);
  };

  return (
    <WhmCard variant="outlined" data-test-id="entity-onboarding-in-review-card">
      <WhmCardContent
        sx={{
          "&:last-child": {
            paddingBottom: "16px",
          },
        }}
      >
        <WhmStack
          sx={{
            flexWrap: {
              xs: "wrap",
              md: "nowrap",
            },
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <WhmStack sx={{ marginRight: "8px", gap: "4px" }}>
            <WhmTypography variant="h4">
              <Translate
                translationKey={translationKeys.ONBOARDING_IN_REVIEW_TITLE}
              />
            </WhmTypography>
            <WhmTypography variant="body2" color="text.secondary">
              <Translate
                translationKey={
                  isNie
                    ? translationKeys.ONBOARDING_IN_REVIEW_COPY_NIE
                    : translationKeys.ONBOARDING_IN_REVIEW_COPY_REGULAR
                }
                replacements={isNie ? { issuerName } : undefined}
              />
            </WhmTypography>
          </WhmStack>
          <WhmButton
            sx={{ flexShrink: 0 }}
            variant="contained"
            size="large"
            onClick={handleCtaClick}
            data-test-id="entity-onboarding-in-review-cta"
          >
            <Translate
              translationKey={
                isNie
                  ? translationKeys.ONBOARDING_IN_REVIEW_BACK_TO_ISSUER
                  : translationKeys.ONBOARDING_IN_REVIEW_EXPLORE_OFFERINGS
              }
              replacements={isNie ? { issuerName } : undefined}
            />
          </WhmButton>
        </WhmStack>
      </WhmCardContent>
    </WhmCard>
  );
}

export default EntityOnboardingInReviewCard;
